<div class="page-wrapper" *transloco="let t; scope: 'errorService'; read: 'errorService'">
  <section class="error-wrapper">
    @if (!title) {
      <h2>{{ t("title") }}</h2>
    }
    @if (!subTitle) {
      <h3>
        {{ t("subtitle") }} <br />
        {{ t("copy_message") }}
      </h3>
    }

    @if (title) {
      <h2>{{ title }}</h2>
    }
    @if (subTitle) {
      <h3>{{ subTitle }}</h3>
    }

    @if (code) {
      <p>{{ t("error_code") }}: {{ code }}</p>
    }
    <p [innerHTML]="sanitizeMessage(message)"></p>

    <div>
      <button (click)="copyToClipboard()" [disabled]="copied">
        @if (!copied) {
          <span>{{ t("click_to_copy") }}</span>
        }
        @if (copied) {
          <span>{{ t("message_copied") }}</span>
        }
      </button>
      <button (click)="clearError()" class="bg-background_interactive">{{ t("close") }}</button>
    </div>
  </section>
</div>
